import React from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import { formatStatsValue } from 'common-helpers/utils';
import Row, { RowBetween } from 'components/Row';
import { AutoColumn } from 'components/Column';
import { TYPE } from 'theme';
import { Card } from '../styled';
import { UserGecStatsV2 } from 'gql-ops/graph/__generated__/request';
import Tooltip from 'components/TooltipInfo';
import { ReactComponent as QuestionSVG } from 'assets/images/dashboard/question.svg';
import { CardContent, PointsTag, Season1Empty, WarningIcon } from './seasonStyles';

const StyledQuestionIcon = styled(QuestionSVG)`
    width: 12px;
    height: 12px;
    cursor: pointer;
    margin-left: 4px;
`;

interface Season2Props {
    gecStatsV2: UserGecStatsV2;
    getInvitationPercentage: () => number;
}

const Season2: React.FC<Season2Props> = ({ gecStatsV2, getInvitationPercentage }) => {
    return (
        <>
            <Row>
                <TYPE.main fontSize={16} fontWeight={700} mobileFz={14}>
                    Season 2 (Ended)
                </TYPE.main>
            </Row>
            {Number(gecStatsV2.season2Stats?.basicPoint) > 0 ? (
                <RowBetween gap="20px" wrap="no-wrap">
                    <Card
                        background="#121212"
                        bgIcon="rocket"
                        height={isMobile ? 'auto' : '169px'}
                        width={isMobile ? '100%' : '600px'}
                        padding="20px"
                        style={{ flexShrink: 0 }}
                    >
                        <CardContent>
                            <AutoColumn gap="6px">
                                <TYPE.desc fontSize={14} fontWeight={500}>
                                    Community Campaign points
                                </TYPE.desc>
                                <TYPE.desc fontSize={10} color="#999">
                                    Community Campaign points is used to receive airdrop.
                                </TYPE.desc>
                            </AutoColumn>
                            <RowBetween gap="20px" align="center" alignItems="center" marginTop="20px" wrap="wrap">
                                <AutoColumn style={{ height: '50px' }}>
                                    <TYPE.main fontSize={10}>Basic points</TYPE.main>
                                    <Row gap="6px" align="center" alignItems="center" marginTop="10px">
                                        <TYPE.main fontSize={24} fontWeight={500}>
                                            +
                                            {formatStatsValue(
                                                BigInt(gecStatsV2.season2Stats?.basicPoint || '0').toString(),
                                            )}
                                        </TYPE.main>
                                        <TYPE.desc fontSize={14}>Points</TYPE.desc>
                                    </Row>
                                </AutoColumn>
                                <AutoColumn style={{ height: '50px' }}>
                                    <Row gap="2px">
                                        <TYPE.main fontSize={10}>Happy birthday NFT holder boost</TYPE.main>
                                        <Tooltip title="NFT Boost rewards will be added after community campaign based on the specific block hight.">
                                            <StyledQuestionIcon />
                                        </Tooltip>
                                    </Row>
                                    <Row
                                        style={{ justifyContent: isMobile ? 'flex-start' : 'center' }}
                                        gap="6px"
                                        alignItems="center"
                                        marginTop="10px"
                                    >
                                        <PointsTag>+20%</PointsTag>
                                    </Row>
                                </AutoColumn>
                                <AutoColumn style={{ height: '50px' }}>
                                    <Row gap="2px">
                                        <TYPE.main fontSize={10}>Invitation boost</TYPE.main>
                                        <Tooltip title="An invitation boost will be applied after the event based on your invite level.">
                                            <StyledQuestionIcon />
                                        </Tooltip>
                                    </Row>
                                    <Row
                                        style={{ justifyContent: isMobile ? 'flex-start' : 'center' }}
                                        gap="6px"
                                        align="center"
                                        alignItems="center"
                                        marginTop="10px"
                                        fontSize="24px"
                                    >
                                        {getInvitationPercentage() ? (
                                            <PointsTag>+{getInvitationPercentage()}%</PointsTag>
                                        ) : (
                                            '0'
                                        )}
                                    </Row>
                                </AutoColumn>
                            </RowBetween>
                        </CardContent>
                    </Card>
                    <Card
                        padding="20px"
                        height="169px"
                        width={isMobile ? '100%' : 'auto'}
                        background="#121212"
                        style={{ flexGrow: 1, flexShrink: 1, minWidth: 0 }}
                    >
                        <CardContent>
                            <AutoColumn gap="6px">
                                <TYPE.main fontSize={14} fontWeight={500}>
                                    My Invitation
                                </TYPE.main>
                                <TYPE.desc fontSize={10}>
                                    Community Campaign points become eligible for rewards
                                </TYPE.desc>
                            </AutoColumn>
                            <Row gap="6px" align="baseline">
                                <div style={{ flex: 1 }}>
                                    <Row gap="2px">
                                        <TYPE.desc fontSize={10}>Members</TYPE.desc>
                                    </Row>
                                    <Row gap="6px" align="center" alignItems="center" marginTop="10px">
                                        <TYPE.main fontSize={24} fontWeight={500}>
                                            {gecStatsV2.season2Stats?.invitationCount || 0}
                                        </TYPE.main>
                                        <TYPE.desc fontSize={14}>People</TYPE.desc>
                                    </Row>
                                </div>
                            </Row>
                        </CardContent>
                    </Card>
                </RowBetween>
            ) : (
                <Season1Empty>
                    <WarningIcon />
                    <TYPE.desc fontSize={12} color="#999" style={{ width: 'fit-content', wordBreak: 'break-word' }}>
                        Opps: You missed the season 2 activities. Please take part in season 3 community campaign and
                        share future rewards.
                    </TYPE.desc>
                </Season1Empty>
            )}
        </>
    );
};

export default Season2;
